import React from "react";
import { Alert, Box, Button, Paper, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const AlertActions = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Actions
        </Typography>

        <Typography variant="body1">
          An alert can have an action, such as a close or undo button. It is
          rendered after the message, at the end of the alert.
        </Typography>
        <Typography variant="body1">
          If an onClose callback is provided and no action prop is set, a close
          icon is displayed. The action prop can be used to provide an
          alternative action, for example using a Button or IconButton.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            value={
              '            <Stack sx={{ width: "100%" }} spacing={2}>\n' +
              "              <Alert onClose={() => {}}>\n" +
              "                This is a success alert — check it out!\n" +
              "              </Alert>\n" +
              "              <Alert\n" +
              "                action={\n" +
              '                  <Button color="inherit" size="small">\n' +
              "                    UNDO\n" +
              "                  </Button>\n" +
              "                }\n" +
              "              >\n" +
              "                This is a success alert — check it out!\n" +
              "              </Alert>\n" +
              "            </Stack>"
            }
          >
            <Stack direction={"column"} sx={{ width: "70%" }} spacing={2}>
              <Alert onClose={() => {}}>
                This is a success alert — check it out!
              </Alert>
              <Alert
                action={
                  <Button color="inherit" size="small">
                    UNDO
                  </Button>
                }
              >
                This is a success alert — check it out!
              </Alert>
            </Stack>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default AlertActions;
